import axios from 'axios';
import { message } from 'antd';
import { baseConfig } from './APIConfig';
import { refreshToken } from '../SharedFunc/User';

let apiBaseUrl = baseConfig.baseurl;
let errorMessage = "Амжилтгүй боллоо. ";

const auth = {
    'Access-Control-Allow-Origin': '*'
};

const API = axios.create({
    baseURL: apiBaseUrl,
    withCredentials: false,
    timeout: 240000,
    headers: auth
});

API.interceptors.request.use(function (config) {

    // if (typeof window != "undefined" && window?.location?.hostname == 'localhost' && config?.url?.toLowerCase()?.indexOf("/api/payroll"?.toLowerCase()) >= 0) {
    //     config.baseURL = "https://localhost:7010";
    // }

    // if (typeof window != "undefined" && window?.location?.hostname == 'localhost' && config?.url?.toLowerCase()?.indexOf("/graphql/payroll"?.toLowerCase()) >= 0) {
    //     config.baseURL = "https://localhost:44316";
    // }

    // if (typeof window != "undefined" && window?.location?.hostname == 'localhost' && config?.url?.toLowerCase()?.indexOf("api/humanresource/Organization"?.toLowerCase()) >= 0) {
    //     config.baseURL = "http://localhost:43538";
    // }

    let accesstoken = null;

    let userInfoResp = localStorage.getItem('userInfo');
    let userInfo = {};
    if (userInfoResp) {
        userInfo = JSON.parse(userInfoResp);
        if (userInfo.accesstoken) {
            accesstoken = userInfo.accesstoken;
        }
    }

    if (config.headers && accesstoken) {
        config.headers.Authorization = `Bearer ${accesstoken}`;
    }
    return config;
}, function (error) {
    message.error(errorMessage + error.message);
    return Promise.reject(error);
});

API.interceptors.response.use(function (response) {

    if (response.status !== 200) {
        message.error(errorMessage + response.message);
    }
    else if (!response?.config?.ignoreRetType && response.data.rettype !== undefined && response.data.rettype !== 0) {
        message.error(errorMessage + response.data.retmsg);
    }

    return response;
}, async function (error) {
    if (error?.response?.status === 401) {
        const originalRequest = error.config;
        if (!originalRequest._retry && !originalRequest.url.endsWith("/refresh-token") && !originalRequest.url.endsWith("/login")) {
            originalRequest._retry = true;
            await refreshToken();
            return API(originalRequest);
        }
        else {
            localStorage.removeItem('userInfo');
            window.location.reload();
        }
    } else if (error?.response?.status === 402) {
        return Promise.reject(error);
    }
    else {
        if (error?.response?.config?.showRetMsg) {
            message.error(error?.response.data);
        } else if (!error?.response?.config?.ignoreRetType) {
            message.error(errorMessage + error.message);
        }
    }
    return Promise.reject(error);
});

export { API };